import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { BitmapFontData } from '../BitmapFontData.mjs';
var XMLFormat = /*#__PURE__*/function () {
  function XMLFormat() {
    _classCallCheck(this, XMLFormat);
  }
  _createClass(XMLFormat, null, [{
    key: "test",
    value: function test(data) {
      var xml = data;
      return "getElementsByTagName" in xml && xml.getElementsByTagName("page").length && xml.getElementsByTagName("info")[0].getAttribute("face") !== null;
    }
  }, {
    key: "parse",
    value: function parse(xml) {
      var data = new BitmapFontData();
      var info = xml.getElementsByTagName("info");
      var common = xml.getElementsByTagName("common");
      var page = xml.getElementsByTagName("page");
      var char = xml.getElementsByTagName("char");
      var kerning = xml.getElementsByTagName("kerning");
      var distanceField = xml.getElementsByTagName("distanceField");
      for (var i = 0; i < info.length; i++) {
        data.info.push({
          face: info[i].getAttribute("face"),
          size: parseInt(info[i].getAttribute("size"), 10)
        });
      }
      for (var _i = 0; _i < common.length; _i++) {
        data.common.push({
          lineHeight: parseInt(common[_i].getAttribute("lineHeight"), 10)
        });
      }
      for (var _i2 = 0; _i2 < page.length; _i2++) {
        data.page.push({
          id: parseInt(page[_i2].getAttribute("id"), 10) || 0,
          file: page[_i2].getAttribute("file")
        });
      }
      for (var _i3 = 0; _i3 < char.length; _i3++) {
        var letter = char[_i3];
        data.char.push({
          id: parseInt(letter.getAttribute("id"), 10),
          page: parseInt(letter.getAttribute("page"), 10) || 0,
          x: parseInt(letter.getAttribute("x"), 10),
          y: parseInt(letter.getAttribute("y"), 10),
          width: parseInt(letter.getAttribute("width"), 10),
          height: parseInt(letter.getAttribute("height"), 10),
          xoffset: parseInt(letter.getAttribute("xoffset"), 10),
          yoffset: parseInt(letter.getAttribute("yoffset"), 10),
          xadvance: parseInt(letter.getAttribute("xadvance"), 10)
        });
      }
      for (var _i4 = 0; _i4 < kerning.length; _i4++) {
        data.kerning.push({
          first: parseInt(kerning[_i4].getAttribute("first"), 10),
          second: parseInt(kerning[_i4].getAttribute("second"), 10),
          amount: parseInt(kerning[_i4].getAttribute("amount"), 10)
        });
      }
      for (var _i5 = 0; _i5 < distanceField.length; _i5++) {
        data.distanceField.push({
          fieldType: distanceField[_i5].getAttribute("fieldType"),
          distanceRange: parseInt(distanceField[_i5].getAttribute("distanceRange"), 10)
        });
      }
      return data;
    }
  }]);
  return XMLFormat;
}();
export { XMLFormat };